import isDemo from '@/lib/utils/is_demo';
import { httpDelete, camelify } from '../rest';


export function deleteClientInvitation(httpDelete, camelify, isDemo) {
  return {
    async execute(deletedClientId) {
      /* istanbul ignore if */

      if (isDemo()) {
        return {
          id: deletedClientId,
        };
      }
      const response = await httpDelete(`/client_invitations/${deletedClientId}`);
      const data = response.data;
      return camelify(data);
    },
  };
}

export default deleteClientInvitation(httpDelete, camelify, isDemo);
